import { useIsFetching, useIsMutating } from "@tanstack/react-query";

import { useAuth } from "~/hooks/useAuth";

export type SyncStatus = {
  state: "signed-out" | "loading" | "syncing" | "offline" | "synced";
  label: string;
  hint: string;
};

/**
 * The app is online-only for signed-in users (react-query over the API,
 * no offline queue), so this just reflects whether a fetch or a write is in
 * flight. `offline` is no longer a state the store can be in.
 */
export function useSyncStatus(): SyncStatus {
  const { user } = useAuth();
  const fetching = useIsFetching();
  const mutating = useIsMutating();

  if (!user) {
    return {
      state: "signed-out",
      label: "Not signed in",
      hint: "Sign in to sync",
    };
  }
  if (mutating > 0) {
    return {
      state: "syncing",
      label: "Saving",
      hint: "Sending your latest changes",
    };
  }
  if (fetching > 0) {
    return {
      state: "loading",
      label: "Loading",
      hint: "Opening your inventory",
    };
  }
  return {
    state: "synced",
    label: "All synced",
    hint: "Everything is backed up",
  };
}
